export enum UserType {
  ORG = "ORG",
  ORG_MANAGER = "ORG_MANAGER",
  NORMAL = "NORMAL",
  ADMIN = "ADMIN"
}

export enum UserV2Type {
  ORG_SUPER_ADMINISTRATOR = "ORG_SUPER_ADMINISTRATOR",
  ORG_ADMINISTRATOR = "ORG_ADMINISTRATOR",
  ORG_MEMBER = "ORG_MEMBER"
}